import { render, staticRenderFns } from "./price-dialog.vue?vue&type=template&id=2715096d&scoped=true&"
import script from "./price-dialog.vue?vue&type=script&lang=js&"
export * from "./price-dialog.vue?vue&type=script&lang=js&"
import style0 from "./price-dialog.vue?vue&type=style&index=0&id=2715096d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715096d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2715096d')) {
      api.createRecord('2715096d', component.options)
    } else {
      api.reload('2715096d', component.options)
    }
    module.hot.accept("./price-dialog.vue?vue&type=template&id=2715096d&scoped=true&", function () {
      api.rerender('2715096d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawMaterials/price-dialog.vue"
export default component.exports